module.exports = __webpack_public_path__ + "static/media/project9.fa476a38.jpg";